import { Environment } from "./types/environment.type";

export const environment: Environment = {
    directusUrl: "https://cms.packbo.recursyve.app",
    googleMapsApiKey: "AIzaSyDieaACIYDkDDMgXG9wQen0Gc0JQ92Hx9M",
    baseUrl: "https://packbo.net",
    deploymentVersion: "1.0.0"
};
